
const columns = () => {
  return [
    {
      title: '岗位分类名称',
      name: 'name',
      dataIndex: 'name',
      searchItem: {},
      tableItem: {
        width: 300
      }
    },
    {
      title: '岗位分类编码',
      name: 'code',
      dataIndex: 'name',
      searchItem: {},
      tableItem: {
        width: 300
      }
    },
    {
      title: '描述',
      name: 'description',
      dataIndex: 'name',
      tableItem: {
        width: 275
      }
    }
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'positionCategory/list',
    ...api
  }
}

const positionCategory = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default positionCategory